import request from '@/utils/request'

export function checkDiscountPasswrod(data) {
  return request({
    url: '/fastFood/checkDiscountPasswrod',
    method: 'post',
    data,
  })
}

export function procedure(data) {
  return request({
    url: '/dish/select',
    method: 'post',
    data,
  })
}

export function order(data) {
  return request({
    url: '/fastFood/order',
    method: 'post',
    data,
  })
}

export function payed(data) {
  return request({
    url: '/fastFood/payed',
    method: 'post',
    data,
  })
}

export function declareTax(data) {
  return request({
    url: '/fastFood/declareTax',
    method: 'post',
    data,
  })
}

export function saveTakeOutInfo(data) {
  return request({
    url: '/deliverInfo/add',
    method: 'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js